import { cloneDeep } from 'lodash';
import actionTypes from '../actions/storeInfo/actionType';

const defaultHotel = {
  storeCode: '',
  storeName: '',
  storeState: '',
  province: '',
  city: '',
  regional: '',
  address: '',
};

const initialState = {
  commonCode: '',
  dataList: [],
  cities: [],
  areas: [],
  currentHotel: defaultHotel,
  hotelDetail: {},
  // currentAlbumData: {}, //  当前门店相册
  // hotelBaseInfoData: {}, // 门店详情基础信息
  hotelDetails: {
    hotelFacilitiesAndServicesList: [],
    hotelFeaturesList: [],
    hotelPrivilegesList: [],
    otherPoliciesList: [],
    reservationMustReadList: [],
    shopInfoDto: {},
    shopPhotoAlbumList: [],
    auditState: '',
    submitTime: '',
    shopPhotoDto: {},
    shopRoomDtoList: [],
    valueAddedServicesList: [],
    commonCode: '',
    exposedLabelList: [],
  },
  hotelDetailsCopy: {}, // copy 详情
  // 门店详情全部信息
  bableList: [],
  infoStatus: '',
  approveInfo: {},
  isApproveOpen: false,
  isApproveSuccessOpen: false,
  infoLoading: false,
  approveInfoLoading: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.INFO_LOADING:
      const { infoLoading } = payload;
      return {
        ...state,
        infoLoading,
      };
    case actionTypes.APPROVE_INFO_LOADING:
      const { approveInfoLoading } = payload;
      return {
        ...state,
        approveInfoLoading,
      };
    case actionTypes.FETCH_HOTEL_LIST:
      const { dataList, currentPage, total } = payload;
      return {
        ...state,
        dataList,
        currentPage,
        total,
      };
    case actionTypes.TOGGLE_HOTEL_MODAL_VISIBLE:
      const { modalVisible, modalType } = payload;
      return {
        ...state,
        modalVisible,
        modalType,
      };
    case actionTypes.SAVE_CURRENT_HOTEL:
      const { currentHotel } = payload;
      return {
        ...state,
        currentHotel,
      };
    case actionTypes.HOTEL_DETAIL_LOADING:
      const { detailLoading } = payload;
      return {
        ...state,
        detailLoading,
      };
    case actionTypes.FETCH_HOTEL_DETAIL:
      const { hotelDetail } = payload;
      return {
        ...state,
        hotelDetail,
      };
    case actionTypes.FTECH_CITY_LIST:
      const { cities } = payload;
      return {
        ...state,
        cities,
      };
    case actionTypes.FETCH_AREA_LIST:
      const { areas } = payload;
      return {
        ...state,
        areas,
      };
    case actionTypes.SAVE_COMMON_CODE:
      const { commonCode } = payload;
      return {
        ...state,
        commonCode,
      };
    // case actionTypes.FETCH_CURR_ALBUM_LIST:
    //   const { data } = payload;
    //   return {
    //     ...state,
    //     currentAlbumData: data,
    //   };
    case actionTypes.UPDATE_CURR_ALBUM_INFO:
      const { hotelDetails } = state;
      const { shopPhotoDto } = hotelDetails;
      const {
        data: { imgType, index, url },
      } = payload;
      let newVal = shopPhotoDto[imgType];
      if (imgType === 'mainImage' || imgType === 'shareImage') {
        newVal = url;
      } else if (payload.type === 'del') {
        newVal.splice(index, 1);
      } else if (payload.type === 'add') {
        let types = 4;
        if (imgType === 'externalList') {
          types = 1;
        }
        if (imgType === 'internalList') {
          types = 2;
        }
        if (imgType === 'guestRoomList') {
          types = 3;
        }
        newVal.push({
          shopPhotoAlbumId: undefined,
          photoUrl: url,
          photoType: 1,
          type: types,
          // sort: newVal.length,
        });
      } else {
        newVal[index].photoUrl = url;
      }
      if (imgType !== 'mainImage' && imgType !== 'shareImage') {
        newVal = newVal.map((item, ind) => {
          return {
            ...item,
            sort: ind,
          };
        });
      }
      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          shopPhotoDto: {
            ...state.hotelDetails.shopPhotoDto,
            [imgType]: newVal,
          },
        },
      };
    case actionTypes.UPDATE_CURR_ALBUM_SORT:
      const { key, list } = payload;

      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          shopPhotoDto: {
            ...state.hotelDetails.shopPhotoDto,
            [key]: list,
          },
        },
      };
    case actionTypes.FETCH_HOTEL_BASE_INFO:
      const { baseDetails } = payload;
      return {
        ...state,
        hotelBaseInfoData: baseDetails,
      };
    case actionTypes.SET_HOTEL_BASE_INFO:
      const { value } = payload;
      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          shopInfoDto: {
            ...state.hotelDetails.shopInfoDto,
            ...value,
          },
        },
      };
    case actionTypes.FETCH_SHOP_INFOS:
      const { datas } = payload;
      return {
        ...state,
        hotelDetails: cloneDeep(datas),
        hotelDetailsCopy: cloneDeep(datas),
      };
    case actionTypes.FETCH_APPROVE_INFO:
      const { approveDetails } = payload;
      return {
        ...state,
        approveInfo: cloneDeep(approveDetails),
      };
    case actionTypes.SET_HOTEL_FACILITIES:
      const { dataObj } = payload;
      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          hotelFacilitiesAndServicesList: dataObj.hotelFacilitiesAndServicesList || [],
          hotelFeaturesList: dataObj.hotelFeaturesList || [],
          hotelPrivilegesList: dataObj.hotelPrivilegesList || [],
          valueAddedServicesList: dataObj.valueAddedServicesList || [],
        },
      };
    case actionTypes.FETCH_EXPOSED_LABEL_LIST:
      const { exposedLabelList } = payload;
      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          exposedLabelList: exposedLabelList || [],
        },
      };
    case actionTypes.FETCH_HOTEL_BABLE_LIST:
      const { bableDate } = payload;
      return {
        ...state,
        bableList: bableDate || [],
      };
    case actionTypes.SET_HOTEL_RULE_LIST:
      const { ruleData } = payload;
      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          reservationMustReadList: ruleData.reservationMustReadList || [],
          otherPoliciesList: ruleData.otherPoliciesList || [],
        },
      };
    case actionTypes.UPDATE_ROOM_TYPE_INFO:
      const { shopRoomDtoList } = payload;
      return {
        ...state,
        hotelDetails: {
          ...state.hotelDetails,
          shopRoomDtoList,
        },
      };
    case actionTypes.INFO_STATUS:
      const { infoStatus } = payload;
      return {
        ...state,
        infoStatus,
      };
    case actionTypes.SET_IS_APPROVE_OPEN:
      return {
        ...state,
        isApproveOpen: payload.isOpen,
      };
    case actionTypes.SET_IS_APPROVE_SUCCESS_OPEN:
      return {
        ...state,
        isApproveSuccessOpen: payload.isOpen,
      };
    default:
      return state;
  }
};
